import { Box, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom";

export const ShopItem = ({ shopItem }) => {
    // console.log('shopItem', shopItem);
    const navigate = useNavigate();
    const handleClick = () => {
        if (shopItem?.id) {
            navigate(`/items/${shopItem.id}`);
        }
    }
    const data = JSON.parse(shopItem?.data || '{}');
    // console.log('data', data);
    return (
        <Box
            sx={{
                borderRadius: '16px',
                border: '1px solid gray',
                height: '150px',
                padding: '8px',
                backgroundColor: 'white',
                cursor: 'pointer',
                ":hover": {
                    border: '1px solid red',
                },
            }}
            onClick={handleClick}
        >
            <Typography>{shopItem?.name || 'Invalid Name'}</Typography>
            <Typography>{data?.price || '0'}</Typography>
        </Box>
    );
}